import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Badge, Button, Col, OverlayTrigger, Row, Tab, Tabs, Tooltip} from "react-bootstrap"
import {Acl, baseUrl, Date, Enums, Files, formatMoney, getPartyIds, qs} from "../../utils"
import {renderIsFetchingData} from "../../utils/grid"

const VARIANT_PAID_DATE = 'PD';
const VARIANT_TAX_DATE_12M = 'TD12M';

const parseYearAndVariant = function (props) {
	let year;
	let variant = '';
	const tab = props.match.params.year;
	if (!tab) {
		year = Date.getToday().getFullYear();
	} else {
		const tokens = ("" + tab).split('-');
		year = tokens[0] * 1;
		if (tokens.length > 1) {
			variant = tokens[1];
		}
	}

	return {year, variant};
}

const getBaseFilter = function (props) {
	const {year, variant} = parseYearAndVariant(props);

	const filter = {
		partyIds: getPartyIds(props.parties),
		paidDateFrom: null,
		paidDateTo: null,
		taxDateFrom: null,
		taxDateTo: null
	}
	if (variant === VARIANT_PAID_DATE) {
		filter['paidDateFrom'] = year + "-01-01";
		filter['paidDateTo'] = (year + 1) + "-01-01";
	} else if (variant === VARIANT_TAX_DATE_12M) {
		filter['taxDateFrom'] = Date.formatDate(Date.addInterval(Date.getToday(), -12, 'months'), null, 'YYYY-MM-DD');
		filter['taxDateTo'] = Date.formatDate(Date.getToday(), null, 'YYYY-MM-DD');
	} else {
		filter['taxDateFrom'] = year + "-01-01";
		filter['taxDateTo'] = (year + 1) + "-01-01";
	}

	return filter;
}

const getPeriod = function (props) {
	const {match: {params}} = props;
	if (params.period || params.period === 0) {
		return ('' + params.period) * 1;
	}
	return 0; // all
};

const getPeriodFrom = function (year, period, party) {
	let m;
	if (period === 0) {
		m = 1;
	} else if (party.extra.vatPeriod === 'QUARTER') {
		m = (period - 1) * 3 + 1;
	} else {
		m = period;
	}
	const d = Date.parseDate(year + "- " + m + "-01");
	return d;
};

const getPeriodTo = function (year, period, party) {
	let m;
	if (party.extra.vatPeriod === 'QUARTER') {
		m = period * 3 + 1;
	} else {
		m = period + 1;
	}
	if (m > 12 || period === 0) {
		year = year + 1;
		m = 1;
	}
	const d = Date.parseDate(year + "- " + m + "-01");
	return d;
};

const isItemEligible = function (item, date, party, filterPartyIds, period) {
	if (item.partyFromId !== party.partyId && item.partyToId !== party.partyId) {
		return false;
	}
	if (filterPartyIds.indexOf(item.partyFromId) >= 0 && filterPartyIds.indexOf(item.partyToId) >= 0) {
		return false;
	}
	if (party.extra.vatPeriod === 'QUARTER') {
		if (period !== 0 && Date.parseDate(date).quarter() !== period) {
			return false;
		}

	} else {
		if (period !== 0 && (Date.parseDate(date).month() + 1) !== period) {
			return false;
		}
	}
	return true;
}

const createGroups = function (items, key) {
	const grouped = {};
	for (let i = 0; i < items[key].length; i++) {
		const item = items[key][i];
		const kk = item.partyFromId + '-' + item.partyToId;
		if (!grouped[kk]) {
			grouped[kk] = [];
		}
		grouped[kk].push(item);
	}
	items[key] = [];
	return grouped;
}

const addTotals = function (totals, key, item, coef) {
	totals[key]['sumAmount']['total'] += coef * item.sumAmount;
	if (totals[key]['taxAmount']) {
		totals[key]['taxAmount']['total'] += coef * item.taxAmount;
		totals[key]['totalAmount']['total'] += coef * item.totalAmount;
	}
	if (coef > 0) {
		totals[key]['sumAmount']['plus'] += coef * item.sumAmount;
		if (totals[key]['taxAmount']) {
			totals[key]['taxAmount']['plus'] += coef * item.taxAmount;
			totals[key]['totalAmount']['plus'] += coef * item.totalAmount;
		}
	} else {
		totals[key]['sumAmount']['minus'] += coef * item.sumAmount;
		if (totals[key]['taxAmount']) {
			totals[key]['taxAmount']['minus'] += coef * item.taxAmount;
			totals[key]['totalAmount']['minus'] += coef * item.totalAmount;
		}
	}
}

const createTotalRow = function (totals, key, k, parts) {
	const totalCells = [
		<th key={1}/>,
		<th key={2}/>,
		<th key={3} className="text-right">{totals[key]['sumAmount'][k] ? formatMoney(totals[key]['sumAmount'][k]) : ''}</th>,
		<th key={4} className="text-right">{totals[key]['taxAmount'] && totals[key]['taxAmount'][k] ? formatMoney(totals[key]['taxAmount'][k]) : ''}</th>,
		<th key={5} className="text-right">{totals[key]['totalAmount'] && totals[key]['totalAmount'][k] ? formatMoney(totals[key]['totalAmount'][k]) : ''}</th>,
		<th key={6}/>,
		<th key={7}/>,
		<th key={8}/>
	];
	for (let j = 0; j < parts.length; j++) {
		totalCells.push(<th key={'part' + j} className="text-right">{key === 'items' ? formatMoney(totals[parts[j]]['sumAmount'][k]) : ''}</th>);
	}
	totalCells.push(<th key={9} className="text-right"/>);
	return <tr key={k} className={'total-row'}>
		{totalCells}
	</tr>
};

class InvoicesInfo extends Component {

	constructor(props) {
		super(props);

		const filter = getBaseFilter(props);

		this.state = {
			filter: {
				...filter,
				// "statuses": ["NEW", "ACTIVE"],

				"search": "",
				"orderCol": "issuedDate, invoiceNo",
				"orderDir": "a",
				"start": 0,
				"rows": 10000
			},
			action: null,
			actionModalOpen: null,
			actionItems: [],
			collapsed: {},
			grouped: {}
		};

		this.formatParty = this.formatParty.bind(this);

		this.handleTabSelect = this.handleTabSelect.bind(this);
	}

	componentDidMount() {
		const {location} = this.props;
		let filter = Object.assign({}, this.state.filter);

		if (location && location.search) {
			filter = Object.assign(filter, qs.parse(location.search, {arrayFormat: 'bracket', encode: false, parseNumbers: true}));
		}

		this.setState({filter: filter}, () => {
			// this.props.onFetchEnums(["xxxBranches", "xxx"],  null, filter);
			this.props.onFetchData(filter);
		});
	}

	componentDidUpdate(prevProps) {
		const {location} = this.props;
		let filter = Object.assign({}, this.state.filter);

		let updated = false;
		if (prevProps.location.search !== location.search) {
			filter = Object.assign(filter, qs.parse(location.search, {arrayFormat: 'bracket', encode: false, parseNumbers: true}));
			updated = true;
		} else if (prevProps.match && prevProps.match.params !== this.props.match.params) {
			filter = Object.assign(filter, getBaseFilter(this.props));
			filter = Object.assign(filter, this.props.match.params);
			updated = true;
		}
		if (updated) {
			this.setState({filter: filter}, () => {
				this.props.onFetchData(filter);
			});
		}
	}

	// onFetchData(filter) {
	// 	const {location} = this.props;
	//
	// 	if (this.props.history) {
	// 		const q = "?" + qs.stringify(filter, {arrayFormat: 'bracket', encode: false});
	// 		console.log("stringify: " + JSON.stringify(filter));
	// 		console.log("array? " + Array.isArray(filter.statuses));
	// 		console.log("stringify: " + q);
	// 		if (location.search !== q) {
	// 			this.props.history.push(location.pathname + q);
	// 			console.log("changing url ...");
	// 		} else {
	// 			this.props.onFetchData(filter);
	// 			console.log("fetching directly ...");
	// 		}
	// 	} else {
	// 		this.props.onFetchData(filter);
	// 	}
	// }

	formatInvoiceRow(item) {
		return 'invoice-' + item.status.toLowerCase()
	}

	formatInvoiceStatus(cell, row, userParties) {
		let ico = "question";
		let text = null;
		let variant = "danger";
		let title = "?";
		let delay = 0;
		let className = null;
		switch (cell) {
			case "OUTLOOK":
				ico = "binoculars";
				variant = "info";
				title = Date.formatDate(row.dueDate);
				break;

			case "PAID":
				const trnPage = this.props.trnPage;
				const transactions = [];
				if (trnPage.items) {
					for (let i = 0; i < trnPage.items.length; i++) {
						if (trnPage.items[i].invoiceId === row.invoiceId) {
							const trn = trnPage.items[i];
							transactions.push(<tr key={trn.trnId}>
								<th>{Date.formatDate(trn.effDate)}</th>
								<td>{trn.varSym}</td>
								<td className={"text-right"}>{formatMoney(trn.trnAmount)}</td>
								<td className={"trn-description"}>{trn.description}</td>
							</tr>);
						}
					}
				}
				ico = "check";
				variant = transactions.length ? "success" : "info";
				title = <div>
					<strong>{row.title}</strong><br/>
					Splatnost: <strong>{Date.formatDate(row.dueDate)}</strong><br/>
					Uhrazeno: <strong>{Date.formatDate(row.paidDate)}</strong>
					{transactions.length ? <table>
						<tbody>{transactions}</tbody>
					</table> : null}
				</div>;
				break;

			case "PENDING":
				ico = "hourglass";
				title = Date.formatDate(row.dueDate);

				const days = Date.durationDays(row.dueDate, Date.getToday());
				if (days <= 1) {
					variant = "danger";
				} else if (days > 21) {
					variant = "secondary";
				} else {
					variant = "warning";
				}
				text = days;

				if (row.accountFromId && userParties.indexOf(row.partyFromId) < 0) {
					const url = baseUrl() + "rest-service/invoice/" + row.invoiceId + "/qr";
					delay = 500;
					className = 'opaque';
					title = <div>
						<strong>{row.title}</strong><br/>
						Splatnost: <strong>{Date.formatDate(row.dueDate)}</strong><br/>
						<a href={url} target={'_blank'}>
							<img src={url} width={256} height={256} alt={'QR kód'}/>
						</a>
					</div>
				}

				break;

			case "SENT":
				ico = "warning";
				variant = "warning";
				title = Date.formatDate(row.dueDate);
				break;
			default:
		}

		return <OverlayTrigger placement="top" delay={delay} overlay={<Tooltip className={className} id={row.invoiceId + '-status'}>{title}</Tooltip>}>
			<Badge variant={variant}>{text !== null ? text : <span className={"fa fa-" + ico}/>}</Badge>
		</OverlayTrigger>
	}

	formatTrnStatus(cell, trn) {
		let ico = "question";
		let text = null;
		let variant = "danger";
		let title = "?";
		let delay = 0;
		let className = null;
		switch (cell) {
			case "PROCESSED":
				const invPage = this.props.invPage;
				const invoices = [];
				if (invPage.items) {
					for (let i = 0; i < invPage.items.length; i++) {
						if (invPage.items[i].invoiceId === trn.invoiceId) {
							const invoice = invPage.items[i];
							invoices.push(<tr key={invoice.invoiceId}>
								<th>{Date.formatDate(invoice.paidDate)}</th>
								<td>{invoice.varSym}</td>
								<td className={"text-right"}>{formatMoney(invoice.totalAmount)}</td>
								<td className={"trn-description"}>{invoice.title}</td>
							</tr>);
						}
					}
				}
				ico = "check";
				variant = invoices.length ? "success" : "info";
				title = <div>
					<strong>{trn.description}</strong><br/>
					{invoices.length ? <table>
						<tbody>{invoices}</tbody>
					</table> : null}
				</div>;
				break;

			case "PENDING":
				const {filter} = this.state;
				ico = "hourglass";
				variant = "warning";
				title = Date.formatDate(trn.effDate);
				text = <span style={{cursor: "pointer"}} onClick={() => this.props.onShowModal(
					<span>Založení faktury {trn.partyFromId} -> {trn.partyToId}</span>,
					<div>
						Skutečně založit fakturu z transakce z {Date.formatDate(trn.trnDate)} na {formatMoney(trn.trnAmount)}:
						<pre>{trn.description}</pre>
					</div>,
					{style: 'success', label: 'Založit fakturu', icon: 'plus'},
					() => this.props.onCreateInvoiceFromTrn(trn.trnId).then((json) => {
						if (json && json.response && json.response.result === 'OK') {
							this.props.onFetchData(filter);
						} else {
							return new Promise((resolve, reject) => reject())
						}
					})
				)}><span className={"fa fa-plus"}/></span>;
				break;

			case "SKIPPED":
				ico = "warning";
				variant = "warning";
				title = Date.formatDate(trn.effDate);
				break;
			default:
		}

		return <OverlayTrigger placement="top" delay={delay} overlay={<Tooltip className={className} id={trn.trnId + '-status'}>{title}</Tooltip>}>
			<Badge variant={variant}>{text ? text : <span className={"fa fa-" + ico}/>}</Badge>
		</OverlayTrigger>
	}

	formatTrnType(cell, row) {
		let ico = "question";
		switch (cell) {
			case "TRANSFER":
				ico = "exchange";
				break;

			case "CARD":
				ico = "credit-card";
				break;

			case "FEE":
				ico = "bank";
				break;

			case "DEPOSIT":
			case "CASH":
				ico = "money";
				break;
			default:
		}

		return <span title={cell} className={"fa fa-" + ico}/>
	}

	formatParty(cell, row) {
		const {enums} = this.props;
		const {filter} = this.state;
		let id = filter.partyIds.indexOf(row.partyFromId) >= 0
			? row.partyToId
			: row.partyFromId;
		const p = Enums.getEnumById(enums, 'parties', id);
		return <span title={p.title}>{p.abbr}</span>
	}

	handleTabSelect(tab) {
		let abbr;
		if (this.props.parties.length > 1) {
			abbr = 'all';
		} else {
			abbr = this.props.parties[0].abbr;
		}
		this.props.history.push('/' + abbr + '/' + tab)
	}

	createTable(id, table, noButton) {
		const {collapsed, grouped} = this.state;
		return <div key={'wrapper-' + id} className={"table-wrapper"}>
			{noButton && !grouped[id] ? '' : <div>
				{noButton ? null : <Button size={'sm'} variant={'dark'} className={'btn-collapse'} onClick={() => {
					if (collapsed[id]) {
						collapsed[id] = undefined
					} else {
						collapsed[id] = true
					}
					this.setState({collapsed})
				}}><span className={"fa fa-" + (collapsed[id] ? "plus" : "minus")}/></Button>}
				{collapsed[id] ? null : <Button size={'sm'} variant={'dark'} className={'btn-collapse btn-group'} onClick={() => {
					if (grouped[id]) {
						grouped[id] = undefined
					} else {
						grouped[id] = true
					}
					this.setState({grouped})
				}}><span className={"fa fa-" + (grouped[id] ? "undo" : "compress")}/></Button>}
			</div>}
			{collapsed[id] ? <div style={{marginTop: "20px", height: "7px"}}>...</div> : table}
		</div>
	}

	renderInvoices(period) {
		const {parties, invPage, enums} = this.props;
		if (invPage.items === null || invPage.isFetchingItems) {
			return renderIsFetchingData();
		}

		const rows = {inc: [], out: [], intra: [], tax: [], other: []};

		const totals = {
			items: {
				sumAmount: {plus: 0, minus: 0, total: 0},
				taxAmount: {plus: 0, minus: 0, total: 0},
				totalAmount: {plus: 0, minus: 0, total: 0},
			}
		};
		for (let k in rows) {
			if (rows.hasOwnProperty(k)) {
				totals[k] = {
					sumAmount: {plus: 0, minus: 0, total: 0},
					taxAmount: {plus: 0, minus: 0, total: 0},
					totalAmount: {plus: 0, minus: 0, total: 0},
				}
			}
		}

		const parts = [];
		for (let i = 0; i < parties.length; i++) {
			const party = parties[i];
			if (party.extra && party.extra.partners) {
				for (let j = 0; j < party.extra.partners.length; j++) {
					const partner = party.extra.partners[j];
					if (parts.indexOf(partner.partyAbbr) >= 0) {
						continue;
					}
					parts.push(partner.partyAbbr);
					totals[partner.partyAbbr] = {
						sumAmount: {plus: 0, minus: 0, total: 0}
					}
				}
			}
		}

		const userParties = getPartyIds(this.props.session.user.parties);

		const items = {inc: [], out: [], intra: [], tax: [], other: []};
		for (let i = 0; i < parties.length; i++) {
			const party = parties[i];
			for (let j = 0; j < invPage.items.length; j++) {
				const item = invPage.items[j];
				if (!isItemEligible(item, item.taxDate, party, this.state.filter.partyIds, period)) {
					continue;
				}
				item.coef = party.partyId === item.partyFromId ? 1 : -1;

				if ((userParties.indexOf(item.partyFromId) >= 0 || item.partyFromId === 587 /*XXX*/) && userParties.indexOf(item.partyToId) >= 0) {
					items.intra.push(item);
				} else if (userParties.indexOf(item.partyFromId) >= 0) {
					items.inc.push(item);
				} else {
					if (item.accountFromType && item.accountFromType.indexOf("TAX_") === 0) {
						items.tax.push(item);
					} else if (item.parts && Object.keys(item.parts).length && item.invoiceNo) {
						items.out.push(item);
					} else {
						items.other.push(item);
					}
				}
			}
		}

		for (let k in this.state.grouped) {
			if (!k.startsWith('inv') || !this.state.grouped.hasOwnProperty(k) || !this.state.grouped[k]) {
				continue;
			}
			const key = k.split('-')[k.split('-').length - 1];
			const grouped = createGroups(items, key);
			for (let kk in grouped) {
				if (!grouped.hasOwnProperty(kk)) {
					continue;
				}
				const head = grouped[kk][0];
				const merged = {
					abbr: grouped[kk].length + 'x',
					title: [],
					taxDate: head.taxDate,
					partyFromId: head.partyFromId,
					partyToId: head.partyToId,
					sumAmount: grouped[kk].map(item => item.sumAmount).reduce((a, b) => a + b),
					taxAmount: grouped[kk].map(item => item.taxAmount).reduce((a, b) => a + b),
					totalAmount: grouped[kk].map(item => item.totalAmount).reduce((a, b) => a + b),
					parts: [],
					status: head.status,
					coef: head.coef
				}
				for (let i = 0; i < grouped[kk].length; i++) {
					const item = grouped[kk][i];
					merged.title.push(item.taxDate + ': ' + item.title);
					if (item.parts) {
						for (let j in item.parts) {
							if (!item.parts.hasOwnProperty(j)) {
								continue;
							}
							if (!merged.parts[j]) {
								merged.parts[j] = {sumAmount: 0, taxAmount: 0, totalAmount: 0};
							}
							merged.parts[j].sumAmount += item.parts[j].sumAmount;
							merged.parts[j].taxAmount += item.parts[j].taxAmount;
							merged.parts[j].totalAmount += item.parts[j].totalAmount;
						}
					}
				}
				merged.title = merged.title.join(',\n');
				items[key].push(merged);
			}
		}

		for (let k in items) {
			if (!items.hasOwnProperty(k)) {
				continue;
			}
			for (let j = 0; j < items[k].length; j++) {
				const item = items[k][j];

				const coef = item.coef;

				addTotals(totals, 'items', item, coef);

				const actions = [];
				if (item.fileId) {
					actions.push(<a key={'file'} href={Files.getLink(item.fileId)} target={'_blank'}><i className={'fa fa-file'}/></a>)
					// actions.push(<a key={'file'} href={"rest-service/file/" + item.fileId}><span className={'fa fa-file'} /></a>)
				}
				if (Acl.hasAction(item, Acl.invoice.EDIT)) {
					actions.push(<Link key={'edit'} to={{pathname: "/invoices/" + item.invoiceId}}><i className="fa fa-pencil"/></Link>)
				}

				const cols = [
					// <td key={'title'} className="text-left">
					// 	<div style={{maxWidth: "200px", overflow: "hidden", maxHeight: "1.5em"}}>{item.title}</div>
					// </td>,
					<td key={'title'} className="text-left" title={item.title}>{item.abbr}</td>,
					<td key={'party'} className="text-center">{this.formatParty(item.invoiceId, item)}</td>,
					<td key={'sumAmount'} className="text-right">{formatMoney(coef * item.sumAmount)}</td>,
					<td key={'taxAmount'} className="text-right">{item.taxAmount === 0 ? null : formatMoney(coef * item.taxAmount)}</td>,
					<td key={'totalAmount'} className="text-right">{formatMoney(coef * item.totalAmount)}</td>,
					<td key={'invoiceNo'} className="text-center">{item.invoiceNo}</td>,
					<td key={'taxDate'} className="text-center">{Date.formatDate(item.taxDate)}</td>,
					<td key={'status'} className="text-center">{this.formatInvoiceStatus(item.status, item, userParties)}</td>,
				];

				for (let j = 0; j < parts.length; j++) {
					let v = null;
					const p = Enums.getEnumByAbbr(enums, 'parties', parts[j]);
					const partPartyId = p && p.id ? 1 * p.id : 0;
					if (item.parts) {
						for (let partyId in item.parts) {
							if (!item.parts.hasOwnProperty(partyId)) {
								continue;
							}
							if (partyId * 1 === partPartyId) {
								addTotals(totals, parts[j], item.parts[partyId], coef);
								v = formatMoney(coef * item.parts[partyId].sumAmount);
								break;
							}
						}
					}
					cols.push(<td key={'part' + j} className="text-right">{v}</td>);
				}
				cols.push(<td key={'actions'} className="text-right" title={JSON.stringify(item)}>{actions}</td>);

				const row = <tr key={j} className={this.formatInvoiceRow(item)}>
					{cols}
				</tr>;

				addTotals(totals, k, item, coef);
				rows[k].push(row);
			}
		}

		const cols = [
			<col key={1} width={(41 - 7 * parts.length) + '%'}/>,
			<col key={2} width='9%'/>,
			<col key={3} width='8%'/>,
			<col key={4} width='8%'/>,
			<col key={5} width='8%'/>,
			<col key={6} width='9%'/>,
			<col key={7} width='8%'/>,
			<col key={8} width='3%'/>
		];

		const heads = [
			<th key={1}>Popis</th>,
			<th key={2} className={"text-center"}>Subjekt</th>,
			<th key={3} className={"text-right"}>Částka</th>,
			<th key={4} className={"text-right"}>DPH</th>,
			<th key={5} className={"text-right"}>Celkem</th>,
			<th key={6} className={"text-center"}>Číslo</th>,
			<th key={7} className={"text-center"}>DUZP</th>,
			<th key={8} className={"text-center"}>S</th>
		];

		for (let j = 0; j < parts.length; j++) {
			cols.push(<col key={'part' + j} width='7%'/>);
			heads.push(<th key={'part' + j} className="text-right">{parts[j]}</th>);
		}
		cols.push(<col key={9} width='6%'/>);
		heads.push(<th key={9} className="text-right">&nbsp;</th>);

		const colgroup =
			<colgroup>
				{cols}
			</colgroup>;

		const tables = [];
		if (rows.inc.length > 1) {
			rows.inc.push(createTotalRow(totals, 'inc', 'total', parts))
		}

		tables.push(this.createTable('inv-inc', <table key={'inc'} className={"table table-striped"}>
			{colgroup}
			<thead>
			<tr>
				{heads}
			</tr>
			</thead>
			<tbody>
			{rows.inc}
			</tbody>
		</table>, rows.inc.length <= 1))

		if (rows.out.length) {
			if (rows.out.length > 1) {
				rows.out.push(createTotalRow(totals, 'out', 'total', parts))
			}

			tables.push(this.createTable('inv-out', <table key={'out'} className={"table table-striped"}>
				{colgroup}
				<tbody>
				{rows.out}
				</tbody>
			</table>, rows.out.length <= 1))
		}

		if (rows.other.length) {
			if (rows.other.length > 1) {
				rows.other.push(createTotalRow(totals, 'other', 'total', parts))
			}

			tables.push(this.createTable('inv-other', <table key={'other'} className={"table table-striped"}>
				{colgroup}
				<tbody>
				{rows.other}
				</tbody>
			</table>, rows.other.length <= 1))
		}

		if (rows.intra.length) {
			if (rows.intra.length > 1) {
				rows.intra.push(createTotalRow(totals, 'intra', 'total', parts))
			}

			tables.push(this.createTable('inv-intra', <table key={'intra'} className={"table table-striped"}>
				{colgroup}
				<tbody>
				{rows.intra}
				</tbody>
			</table>, rows.intra.length <= 1))
		}

		if (rows.tax.length) {
			if (rows.tax.length > 1) {
				rows.tax.push(createTotalRow(totals, 'tax', 'total', parts))
			}

			tables.push(this.createTable('inv-tax', <table key={'tax'} className={"table table-striped"}>
				{colgroup}
				<tbody>
				{rows.tax}
				</tbody>
			</table>, rows.tax.length <= 1))
		}

		const totalRows = [];

		for (let k in totals['items']['totalAmount']) {
			totalRows.push(createTotalRow(totals, 'items', k, parts));
		}

		tables.push(this.createTable('sum', <table key={'sum'} className={"table"}>
			{colgroup}
			<tbody>
			{totalRows}
			</tbody>
		</table>, true))

		return tables;
	}

	renderTransactions(period) {
		const {parties, trnPage} = this.props;
		if (trnPage.items === null || trnPage.isFetchingItems) {
			return renderIsFetchingData();
		}

		const rows = {inc: [], out: []};

		const totals = {
			items: {
				sumAmount: {plus: 0, minus: 0, total: 0},
			}
		};
		for (let k in rows) {
			if (rows.hasOwnProperty(k)) {
				totals[k] = {
					sumAmount: {plus: 0, minus: 0, total: 0},
				}
			}
		}

		const items = {inc: [], out: []};
		for (let i = 0; i < parties.length; i++) {
			const party = parties[i];
			for (let j = 0; j < trnPage.items.length; j++) {
				const item = trnPage.items[j];
				if (item.invoiceId) {
					continue;
				}
				if (!isItemEligible(item, item.effDate, party, this.state.filter.partyIds, period)) {
					continue;
				}

				if (item.trnDir === 'IN') {
					items.inc.push(item);
				} else {
					items.out.push(item);
				}
			}
		}

		for (let k in this.state.grouped) {
			if (!k.startsWith('trn') || !this.state.grouped.hasOwnProperty(k) || !this.state.grouped[k]) {
				continue;
			}
			const key = k.split('-')[k.split('-').length - 1];
			const grouped = createGroups(items, key);
			for (let kk in grouped) {
				if (!grouped.hasOwnProperty(kk)) {
					continue;
				}
				const head = grouped[kk][0];
				const merged = {
					trnId: head.trnId,
					trnDir: head.trnDir,
					effDate: head.effDate,
					trnType: head.trnType,
					description: grouped[kk].length + 'x',
					partyFromId: head.partyFromId,
					partyToId: head.partyToId,
					trnAmount: grouped[kk].map(item => item.trnAmount).reduce((a, b) => a + b),
					varSym: null,
					constSym: null,
					specSym: null,
					fileId: null,
					title: [],
					status: head.status,
				}
				for (let i = 0; i < grouped[kk].length; i++) {
					const item = grouped[kk][i];
					merged.title.push(item.effDate + ': ' + item.description + ' (' + item.varSym + ')');
				}
				merged.title = merged.title.join(',\n');
				items[key].push(merged);
			}
		}

		for (let k in items) {
			if (!items.hasOwnProperty(k)) {
				continue;
			}
			for (let j = 0; j < items[k].length; j++) {
				const item = items[k][j];

				const coef = item.trnDir === 'IN' ? 1 : -1;

				addTotals(totals, 'items', {sumAmount: item.trnAmount}, coef);

				const actions = [];
				if (item.fileId) {
					actions.push(<a key={'file'} href={baseUrl() + "rest-service/file/" + item.fileId} target={'_blank'}><i className={'fa fa-file'}/></a>)
					// actions.push(<a key={'file'} href={"rest-service/file/" + item.fileId}><span className={'fa fa-file'} /></a>)
				}

				const cols = [
					<td key={'effDate'} className="text-center">{Date.formatDate(item.effDate)}</td>,
					<td key={'trnType'} className="text-center">{this.formatTrnType(item.trnType, item)}</td>,
					<td key={'description'} className="text-left" title={item.title || item.description}>{item.description}</td>,
					<td key={'party'} className="text-center">{this.formatParty(item.trnId, item)}</td>,
					<td key={'sumAmount'} className="text-right">{formatMoney(item.trnAmount)}</td>,
					<td key={'varSymbol'} className="text-center">{item.varSym}</td>,
					<td key={'constSymbol'} className="text-center">{item.constSym}</td>,
					<td key={'specSymbol'} className="text-center">{item.specSym}</td>,
					<td key={'status'} className="text-center">{this.formatTrnStatus(item.status, item)}</td>,
				];
				cols.push(<td key={'actions'} className="text-right" title={JSON.stringify(item)}>{actions}</td>);

				const row = <tr key={j}>
					{cols}
				</tr>;

				addTotals(totals, k, {sumAmount: item.trnAmount}, coef);
				rows[k].push(row);
			}
		}

		const cols = [
			<col key={1} width='8%'/>,
			<col key={2} width='8%'/>,
			<col key={3} width='37%'/>,
			<col key={4} width='8%'/>,
			<col key={5} width='8%'/>,
			<col key={6} width='8%'/>,
			<col key={7} width='4%'/>,
			<col key={8} width='8%'/>,
			<col key={9} width='3%'/>,
			<col key={10} width='6%'/>
		];

		const heads = [
			<th key={1}>Datum</th>,
			<th key={2} className={"text-center"}>Typ</th>,
			<th key={3}>Popis</th>,
			<th key={4} className={"text-center"}>Subjekt</th>,
			<th key={5} className={"text-right"}>Částka</th>,
			<th key={6} className={"text-right"}>VS</th>,
			<th key={7} className={"text-right"}>KS</th>,
			<th key={8} className={"text-center"}>SS</th>,
			<th key={9} className={"text-center"}>S</th>,
			<th key={10} className="text-right">&nbsp;</th>
		];


		const colgroup =
			<colgroup>
				{cols}
			</colgroup>;

		const tables = [];
		if (rows.inc.length) {
			if (rows.inc.length > 1) {
				rows.inc.push(
					<tr key={'total'}>
						<th key={1} colSpan={4}/>
						<th key={2} className="text-right">{formatMoney(totals['inc']['sumAmount']['total'])}</th>
						<th key={3} colSpan={4}/>
					</tr>)
			}
			tables.push(this.createTable('trn-inc', <table key={'inc'} className={"table table-striped trn-inc-table"} style={{borderBottom: "1px solid #dee2e6"}}>
				{colgroup}
				<thead>
				<tr>
					{heads}
				</tr>
				</thead>
				<tbody>
				{rows.inc}
				</tbody>
			</table>, rows.inc.length <= 1));
		}

		if (rows.out.length) {
			if (rows.out.length > 1) {
				rows.out.push(
					<tr key={'total'}>
						<th key={1} colSpan={4}/>
						<th key={2} className="text-right">{formatMoney(totals['out']['sumAmount']['total'])}</th>
						<th key={3} colSpan={4}/>
					</tr>)
			}
			tables.push(this.createTable('trn-out', <table key={'out'} className={"table table-striped"}>
				{colgroup}
				{tables.length ? null : <thead>
				<tr>
					{heads}
				</tr>
				</thead>}
				<tbody>
				{rows.out}
				</tbody>
			</table>, rows.out.length <= 2))
		}

		tables.push(this.createTable('trn-sum', <table key={'sum'} className={"table"}>
			{colgroup}
			<tbody>
			<tr key={'plus'}>
				<th key={1} colSpan={4}/>
				<th key={2} className="text-right">{formatMoney(totals['items']['sumAmount']['plus'])}</th>
				<th key={3} colSpan={4}/>
			</tr>
			<tr key={'minus'}>
				<th key={1} colSpan={4}/>
				<th key={2} className="text-right">{formatMoney(totals['items']['sumAmount']['minus'])}</th>
				<th key={3} colSpan={4}/>
			</tr>
			<tr key={'total'}>
				<th key={1} colSpan={4}/>
				<th key={2} className="text-right">{formatMoney(totals['items']['sumAmount']['total'])}</th>
				<th key={3} colSpan={4}/>
			</tr>
			</tbody>
		</table>, true))

		return tables;
	}

	renderTab() {
		const period = getPeriod(this.props);

		const invoices = this.renderInvoices(period);

		const transactions = this.renderTransactions(period);

		return <div className={"dashboard"}>
			{invoices}
			{transactions}
		</div>;
	}

	render() {
		const {parties} = this.props;
		const {year, variant} = parseYearAndVariant(this.props);
		const period = getPeriod(this.props);
		const stub = year + (variant ? '-' + variant : '');
		const tab = stub + '/' + period;

		const tabs = [];
		if (parties.length === 1) {
			const party = parties[0];
			const periods = (party.extra && party.extra.vatPeriod === 'QUARTER') ? 4 : 12;
			for (let i = 0; i < periods; i++) {
				const period = i + 1;
				const key = stub + '/' + period;
				tabs.push(<Tab key={key} eventKey={key} title={(party.extra.vatPeriod === 'QUARTER' ? 'Q' : '') + period} className="invoices-widget-period">
					{tab === key ? <div>{this.renderTab()}</div> : null}
				</Tab>)
			}
		}
		const key = stub + '/0';
		tabs.push(<Tab key={key} eventKey={key} title={'Vše'} className="invoices-widget-period">
			{tab === key ? <div>{this.renderTab()}</div> : null}
		</Tab>);

		const thisYear = Date.getToday().getFullYear();
		const years = [];
		for (let y = 2019; y <= thisYear; y++) {
			years.push(<option key={y} value={y}>{y}</option>);
		}
		for (let y = 2019; y <= thisYear; y++) {
			const yx = y + '-' + VARIANT_PAID_DATE;
			years.push(<option key={yx} value={yx}>{y} {VARIANT_PAID_DATE}</option>);
		}
		const y12 = thisYear + '-' + VARIANT_TAX_DATE_12M;
		years.push(<option key={y12} value={y12}>{VARIANT_TAX_DATE_12M}</option>);

		return (
			<div>
				<Row>
					<Col xs={12}>
						<div className={"year-selector"}>
							<Row>
								<Col xs={4}>
									<a href={baseUrl() + 'rest-service/invoice/package?' + qs.stringify({
										partyIds: this.state.filter.partyIds,
										taxDateFrom: Date.formatDate(getPeriodFrom(year, period, parties[0]), null, "YYYY-MM-DD"),
										taxDateTo: Date.formatDate(getPeriodTo(year, period, parties[0]), null, "YYYY-MM-DD")
									})}><i className={'fa fa-archive'}/> </a>
								</Col>
								<Col xs={8}>
									<select className={"form-control"} value={stub} onChange={(event) =>
										this.handleTabSelect(event.target.value + '/' + 0)}>
										{years}
									</select>
								</Col>
							</Row>
						</div>
						<Tabs activeKey={tab} onSelect={this.handleTabSelect} transition={false} id="invoices-widget">
							{tabs}
						</Tabs>
					</Col>
				</Row>
			</div>
		)
	}
}


InvoicesInfo.propTypes = {
	invPage: PropTypes.object.isRequired,
	trnPage: PropTypes.object.isRequired,
	parties: PropTypes.array.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onUpdateInvoiceStatus: PropTypes.func,
	onCreateInvoiceFromTrn: PropTypes.func.isRequired,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(InvoicesInfo)
